Backbone = require 'backbone'
SupportOptimizedContactChannelsTemplate = require('../../optimized_contact_channels.html.mustache')

class SupportOptimizedContactChannelsModel extends Backbone.Model

  initialize: ->
    @template = SupportOptimizedContactChannelsTemplate

  toHash: ()->
    @toJSON()

  hidePreferencedContactChannel: ->
    optimizedContactChannels = [@optimizephoneBtnElem(), @optimizeEmailBtnElem()]
    removePreferredContactClass optimizedContactChannels
    addBtnSecondaryClass optimizedContactChannels

  showPreferencedContactChannel: (type) ->
    return if @optimizedLiveChatVisible() || ($('.preferred-contact-channel', '.optimized-contact-channels-view').length > 0)
    switch type
      when "email"
        preferredContactElem = @optimizeEmailBtnElem()
      when "phone"
        preferredContactElem = @optimizephoneBtnElem()

    if preferredContactElem
      addPreferredContactClass preferredContactElem
      removeBtnSecondaryClass preferredContactElem

  optimizedLiveChatVisible: ->
    window.liveChatVisible $(".live-chat-container.optimized-contact-channel a img")

  setOptimizedLiveChatDisplayCallBack: (liveChatDisplayCallback)->
    window.setLiveChatDisplayCallBack $(".live-chat-container.optimized-contact-channel a img"), liveChatDisplayCallback

  optimizephoneBtnElem: ->
    $('.optimized-phone-btn')

  optimizeEmailBtnElem: ->
    $('.optimized-email-us')

  optimizedLiveChatContainer: ->
    $('.optimized-live-chat-container')

  emailRecommendationTextElement : ->
    $('.optimized-email-us-p')

  phoneRecommendationTextElement : ->
    $('.optimized-phone-p')

module.exports = SupportOptimizedContactChannelsModel
